import { Modal } from "barte-design-system";
import { useDeleteUser } from "@/services/usersService";
import { showToast } from "@/utils";
import type { ModalDeleteUserProps } from "./modal-delete-user.type";
import styles from "./modal-delete-user.module.css";

export const ModalDeleteUser = ({ isOpen, onClose, user }: ModalDeleteUserProps) => {
  const { mutateAsync: deleteUser, isPending: isDeleting } = useDeleteUser();

  const handleDelete = async () => {
    if (!user) return;

    const response = await deleteUser({ userId: user.id });

    if (response.success) {
      showToast({ type: "success", message: "Usuário excluído com sucesso." });
      onClose();
    } else {
      showToast({ type: "error", message: response.message });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Tem certeza que deseja excluir esse usuário?"
      onClose={onClose}
      footer={{
        primaryButton: {
          children: "Excluir usuário",
          onClick: handleDelete,
          size: "sm",
          round: "soft",
          loading: isDeleting,
        },
        secondaryButton: {
          children: "Cancelar",
          onClick: onClose,
          variant: "outline",
          size: "sm",
          round: "soft",
          disabled: isDeleting,
        },
      }}
    >
      <div className={styles.content}>
        <img
          className={styles.icon}
          src="/images/icons/ExclamationCircleOutlined.svg"
          alt=""
        />
        <span className={styles.message}>
          Essa operação não pode ser desfeita.
        </span>
      </div>
    </Modal>
  );
};
